import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { container } from 'tsyringe'
import { HomePresenter } from '@/app/ui/presenters/HomePresenter'
import { RolePresenter } from '@/app/ui/presenters/RolePresenter'
import { DashboardPresenter } from '@/app/ui/presenters/DashboardPresenter'
import { User } from '@/domain/entities/User'
import { Role } from '@/domain/entities/Role'
import { Dashboard } from '@/domain/entities/Dashboard'

Vue.use(Vuex, axios)

export default new Vuex.Store({
  state: {
    userList: Array<User>(),
    roleList: Array<Role>(),
    report: Array<Dashboard>(),
  },
  actions: {
    loadUser({ commit }) {
      const presenter = container.resolve(HomePresenter)
      presenter
        .loadUser(new Map())
        .then((res: User) => {
          commit('SET_USERLIST', res)
          // tslint:disable-next-line: no-console
          //  console.log('res', res)
        })
        .catch((error) => {
          // tslint:disable-next-line: no-console
          //  console.log('error', error)
        })
    },
    loadRole({ commit }) {
      const presenter = container.resolve(RolePresenter)
      presenter
        .loadRole(new Map())
        .then((res: Role[]) => {
          commit('SET_ROLELIST', res)
          // tslint:disable-next-line: no-console
          //  console.log('res ROLE', res)
        })
        .catch((error: any) => {
          // tslint:disable-next-line: no-console
          //  console.log('error', error)
        })
    },
    loadDashboard({ commit }) {
      const presenter = container.resolve(DashboardPresenter)
      presenter
        .loadDashboard(new Map())
        .then((res: Dashboard) => {
          commit('SET_DASHBOARD', res)
          // tslint:disable-next-line: no-console
          //  console.log('RESP DASHBOARD', res)
        })
        .catch((error: any) => {
          // tslint:disable-next-line: no-console
          //  console.log('error', error)
        })
    },
  },
  mutations: {
    SET_USERLIST(state, userList: User[]) {
      state.userList = userList
    },
    SET_ROLELIST(state, roleList: Role[]) {
      state.roleList = roleList
    },
    SET_DASHBOARD(state, report: Dashboard[]) {
      state.report = report
    },
  },
})
